import { engineComponent, NumberUtils, Utils } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { ContainerElement } from "../../Components/Elements/Graphics/ContainerElement";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../Utils/FrameTimer";
import { Paylines } from "../Paylines";
import { Symbols } from "../Symbols";
import { Machine } from "../Machine";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { StageController } from "../../Components/StageController";
import { WinAnimator } from "../WinAnimator";
import { FreespinsController } from "./FreespinsController";
import { GameManager } from "../../Managers/GameManager";
import { PlayList } from "../../Components/Sounds/PlayList";
import { HtmlController } from "../../HTMLComponents/HtmlController";
import { WinAnimatorFreespins } from "../../CustomComponents/WinAnimatorFreespins";
import { AmbientBackground } from "../../Utils/AmbientBackground";
import { LayoutContainerElement } from "../../CustomComponents/LayoutContainerElement";
import { LayoutSwitchElement } from "../../CustomComponents/LayoutSwitchElement";
import { ModuleManager } from "../../Managers/ModuleManager";
import { ImageTextElement } from "../../Components/Elements/Texts/ImageTextElement";
import { BetManager } from "../../Managers/BetManager";
import { DataManager } from "../../Managers/DataManager";
import { BaseView } from "../Base/BaseView";
import { CustomUtils } from "../../Utils/CustomUtils";
import { SceneHolderElement } from "../../CustomComponents/SceneHolderElement";
import { TimelineElement } from "../../Components/Elements/Graphics/TimelineElement";

@engineComponent(ComponentTypes.DisplayObject)
export class FreespinsView extends LayoutContainerElement {
    public static Transition: SwitchElement;
    public static CustomWinAnimation: TimelineElement;

    public messages: LayoutSwitchElement;
    private _fsMessageTimerFS: FrameTimerEventEmitter;
    private _fsMessageEndTimer: FrameTimerEventEmitter;

    public static customFreespinsCollectionBarsData: any;

    private _controller: FreespinsController;

    public static _bonusCounterFS: LayoutSwitchElement;
    public static _multiplierS5FS: LayoutSwitchElement;
    public static _multiplierS3FS: LayoutSwitchElement;
    public static _multiplierS1FS: LayoutSwitchElement;
    public static _multiplierS6FS: LayoutSwitchElement;
    public static _multiplierS4FS: LayoutSwitchElement;
    public static _multiplierS2FS: LayoutSwitchElement;

    public static symbol6MultiplierCount: number;
    public static symbol5MultiplierCount: number;
    public static symbol4MultiplierCount: number;
    public static symbol3MultiplierCount: number;
    public static symbol2MultiplierCount: number;
    public static symbol1MultiplierCount: number;

    public static s6MultiplierCount: number;
    public static s5MultiplierCount: number;
    public static s4MultiplierCount: number;
    public static s3MultiplierCount: number;
    public static s2MultiplierCount: number;
    public static s1MultiplierCount: number;

    public static symbol6hasWin: number;
    public static symbol5hasWin: number;
    public static symbol4hasWin: number;
    public static symbol3hasWin: number;
    public static symbol2hasWin: number;
    public static symbol1hasWin: number;

    private _introDelay: FrameTimerEventEmitter;
    private _outroDelay: FrameTimerEventEmitter;

    private _totalWinTimer: FrameTimerEventEmitter;
    public static totalWinBeforeFeature: number;
    public static totalWinPopS1: number;
    public static totalWinPopS2: number;
    public static totalWinPopS3: number;
    public static totalWinPopS4: number;
    public static totalWinPopS5: number;
    public static totalWinPopS6: number;

    public static totalWinFinished: number;

    private _popS1Timer: FrameTimerEventEmitter;
    private _popS2Timer: FrameTimerEventEmitter;
    private _popS3Timer: FrameTimerEventEmitter;
    private _popS4Timer: FrameTimerEventEmitter;
    private _popS5Timer: FrameTimerEventEmitter;
    private _popS6Timer: FrameTimerEventEmitter;

    private _popS1CounterTimer: FrameTimerEventEmitter;
    private _popS2CounterTimer: FrameTimerEventEmitter;
    private _popS3CounterTimer: FrameTimerEventEmitter;
    private _popS4CounterTimer: FrameTimerEventEmitter;
    private _popS5CounterTimer: FrameTimerEventEmitter;
    private _popS6CounterTimer: FrameTimerEventEmitter;

    private _popS1SoundTimer: FrameTimerEventEmitter;
    private _popS2SoundTimer: FrameTimerEventEmitter;
    private _popS3SoundTimer: FrameTimerEventEmitter;
    private _popS4SoundTimer: FrameTimerEventEmitter;
    private _popS5SoundTimer: FrameTimerEventEmitter;
    private _popS6SoundTimer: FrameTimerEventEmitter;

    private _startCustomAnimationTimer: FrameTimerEventEmitter;

    private _paylines: Paylines;
    private _symbols: Symbols;
    private _machine: Machine;
    private _winAnimator: WinAnimatorFreespins;
    private _noWinContainer: ContainerElement;
    private _symbolsContainer: ContainerElement;

    private _fsMessageStart: HTMLElement;
    private _fsMessageEnd: HTMLElement;
    private _fsMessageEndNoWin: HTMLElement;

    constructor() {
        super();

        this._introDelay = CreateFrameTimer("introDelay");
        this._introDelay.on(FrameTimerEvents.Complete, this.introFinished.bind(this));

        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));

        this._fsMessageEndTimer = CreateFrameTimer("fsMessageEndTimer");
        this._fsMessageEndTimer.on(FrameTimerEvents.Complete, this.showFsMessageEnd.bind(this));

        this._fsMessageTimerFS = CreateFrameTimer("fsMessageDelay");
        this._fsMessageTimerFS.on(FrameTimerEvents.Complete, this.showFsMessageFS.bind(this));

        this._totalWinTimer = CreateFrameTimer("totalWinTimer");
        this._totalWinTimer.on(FrameTimerEvents.Complete, this.totalWin.bind(this));

        this._popS1Timer = CreateFrameTimer("popS1timer");
        this._popS1Timer.on(FrameTimerEvents.Complete, this.popS1totalwin.bind(this));

        this._popS2Timer = CreateFrameTimer("popS2timer");
        this._popS2Timer.on(FrameTimerEvents.Complete, this.popS2totalwin.bind(this));

        this._popS3Timer = CreateFrameTimer("popS3timer");
        this._popS3Timer.on(FrameTimerEvents.Complete, this.popS3totalwin.bind(this));

        this._popS4Timer = CreateFrameTimer("popS4timer");
        this._popS4Timer.on(FrameTimerEvents.Complete, this.popS4totalwin.bind(this));

        this._popS5Timer = CreateFrameTimer("popS5timer");
        this._popS5Timer.on(FrameTimerEvents.Complete, this.popS5totalwin.bind(this));

        this._popS6Timer = CreateFrameTimer("popS6timer");
        this._popS6Timer.on(FrameTimerEvents.Complete, this.popS6totalwin.bind(this));

        this._popS1CounterTimer = CreateFrameTimer("popS1CounterTimer");
        this._popS1CounterTimer.on(FrameTimerEvents.Complete, this.popS1counter.bind(this));

        this._popS2CounterTimer = CreateFrameTimer("popS2CounterTimer");
        this._popS2CounterTimer.on(FrameTimerEvents.Complete, this.popS2counter.bind(this));

        this._popS3CounterTimer = CreateFrameTimer("popS3CounterTimer");
        this._popS3CounterTimer.on(FrameTimerEvents.Complete, this.popS3counter.bind(this));

        this._popS4CounterTimer = CreateFrameTimer("popS4CounterTimer");
        this._popS4CounterTimer.on(FrameTimerEvents.Complete, this.popS4counter.bind(this));

        this._popS5CounterTimer = CreateFrameTimer("popS5CounterTimer");
        this._popS5CounterTimer.on(FrameTimerEvents.Complete, this.popS5counter.bind(this));

        this._popS6CounterTimer = CreateFrameTimer("popS6CounterTimer");
        this._popS6CounterTimer.on(FrameTimerEvents.Complete, this.popS6counter.bind(this));

        this._popS1SoundTimer = CreateFrameTimer("popS1SoundTimer");
        this._popS1SoundTimer.on(FrameTimerEvents.Complete, this.popS1sound.bind(this));

        this._popS2SoundTimer = CreateFrameTimer("popS2SoundTimer");
        this._popS2SoundTimer.on(FrameTimerEvents.Complete, this.popS2sound.bind(this));

        this._popS3SoundTimer = CreateFrameTimer("popS3SoundTimer");
        this._popS3SoundTimer.on(FrameTimerEvents.Complete, this.popS3sound.bind(this));

        this._popS4SoundTimer = CreateFrameTimer("popS4SoundTimer");
        this._popS4SoundTimer.on(FrameTimerEvents.Complete, this.popS4sound.bind(this));

        this._popS5SoundTimer = CreateFrameTimer("popS5SoundTimer");
        this._popS5SoundTimer.on(FrameTimerEvents.Complete, this.popS5sound.bind(this));

        this._popS6SoundTimer = CreateFrameTimer("popS6SoundTimer");
        this._popS6SoundTimer.on(FrameTimerEvents.Complete, this.popS6sound.bind(this));

        this._startCustomAnimationTimer = CreateFrameTimer("startCustomAnimation");

        StageController.freespinsStageContainer = this;
    }

    create(node: Element): void {
        super.create(node);

        if (this.childs != null) {
            for (let key in this.childs) {
                if (this.childs[key] instanceof Paylines) {
                    this._paylines = this.childs[key];
                    this._paylines.reset();
                }

                if (this.childs[key] instanceof Symbols) {
                    this._symbols = this.childs[key];
                    this.removeChild(this._symbols);
                }

                if (this.childs[key] instanceof Machine) {
                    this._machine = this.childs[key];
                }

                if (this.childs[key] instanceof WinAnimatorFreespins) {
                    this._winAnimator = this.childs[key];
                }

                if (key === "NoWinContainer" && this.childs[key] instanceof ContainerElement) {
                    this._noWinContainer = this.childs[key];
                }

                if (key === "BonusFeatureCounterFS" && this.childs[key] instanceof LayoutSwitchElement) {
                    FreespinsView._bonusCounterFS = this.childs[key];
                }

                if (key === "Transition" && this.childs[key] instanceof SwitchElement) {
                    FreespinsView.Transition = this.childs[key];
                }

                if (key === "SymbolsContainer" && this.childs[key] instanceof ContainerElement) {
                    this._symbolsContainer = this.childs[key];
                }

                if (key === "Messages" && this.childs[key] instanceof LayoutSwitchElement) {
                    this.messages = this.childs[key];
                }

                if (key === "MultiplierS5FS" && this.childs[key] instanceof LayoutSwitchElement) {
                    FreespinsView._multiplierS5FS = this.childs[key];
                }

                if (key === "MultiplierS3FS" && this.childs[key] instanceof LayoutSwitchElement) {
                    FreespinsView._multiplierS3FS = this.childs[key];
                }

                if (key === "MultiplierS1FS" && this.childs[key] instanceof LayoutSwitchElement) {
                    FreespinsView._multiplierS1FS = this.childs[key];
                }

                if (key === "MultiplierS6FS" && this.childs[key] instanceof LayoutSwitchElement) {
                    FreespinsView._multiplierS6FS = this.childs[key];
                }

                if (key === "MultiplierS4FS" && this.childs[key] instanceof LayoutSwitchElement) {
                    FreespinsView._multiplierS4FS = this.childs[key];
                }

                if (key === "MultiplierS2FS" && this.childs[key] instanceof LayoutSwitchElement) {
                    FreespinsView._multiplierS2FS = this.childs[key];
                }
            }

            this._fsMessageStart = document.getElementById("fsMessageStart");
            this._fsMessageEnd = document.getElementById("fsMessageEnd");
            this._fsMessageEndNoWin = document.getElementById("fsMessageEndNoWin");

            FreespinsView.CustomWinAnimation = CustomUtils.getObjectFrom(
                "CustomWinAnimation",
                this.childs,
                TimelineElement,
            );

            if (DEBUG) {
                if (this._paylines == null) {
                    this.log("WARNING no paylines");
                }

                if (this._symbols == null) {
                    this.log("ERROR no symbols");
                }

                if (this._machine == null) {
                    this.log("ERROR no machine");
                }

                if (this._winAnimator == null) {
                    this.log("WARNING no winAnimator");
                }

                if (this._fsMessageStart == null) {
                    this.log("ERROR no fsMessageStart");
                }

                if (this._fsMessageEnd == null) {
                    this.log("ERROR no fsMessageEnd");
                }

                if (this._fsMessageEndNoWin == null) {
                    this.log("ERROR no fsMessageEndNoWin");
                }
            }
        }
    }

    disableLogo(): void {
        if (this.childs["Logo"] != null) {
            this.removeChild(this.childs["Logo"]);
        }
    }

    initReceived(controller: FreespinsController): void {
        if (DEBUG) {
            this.log("initReceived");
        }

        this._controller = controller;

        if (this._symbols != null) {
            if (this._machine != null) {
                if (GameManager.freespinsResponse != null) {
                    if (
                        GameManager.freespinsResponse.initData != null &&
                        GameManager.freespinsResponse.initData.reels !== null
                    ) {
                        this._machine.on(Machine.ReelStopped, this.onReelStopped.bind(this));
                        this._machine.on(Machine.MachineStopped, this.machineStopped.bind(this));
                        this._machine.initialize(
                            this._symbols,
                            GameManager.freespinsResponse.initData.reels,
                            this.childs["Teasing"],
                        );
                    }

                    if (this._winAnimator != null) {
                        this._winAnimator.on(WinAnimator.FinishWinCalculation, this.finishWinCalculation.bind(this));
                        this._winAnimator.on(WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
                        this._winAnimator.on(
                            WinAnimator.FinishQuickWinCalculation,
                            this.finishQuickWinCalculation.bind(this),
                        );

                        this._winAnimator.on(
                            WinAnimatorFreespins.FinishCustomWinCalculation,
                            this.finishCustomWinCalculation.bind(this),
                        );
                        this._winAnimator.on(
                            WinAnimatorFreespins.FinishCustomWinAnimator,
                            this.finishCustomWinAnimator.bind(this),
                        );
                        this._winAnimator.on(
                            WinAnimatorFreespins.FinishCustomQuickWinCalculation,
                            this.finishCustomQuickWinCalculation.bind(this),
                        );

                        this._winAnimator.currentWinSymbolsContainer = this.childs["CurrentWinSymbolsContainer"];
                        this._winAnimator.initialize(
                            this._symbols,
                            this._paylines,
                            this._noWinContainer,
                            this._symbolsContainer,
                        );
                    }
                } else {
                    if (DEBUG) {
                        this.log("ERROR no freespin reponse");
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no symbols");
            }
        }

        this.visible = false;
    }

    initIntro(): void {
        StageController.baseStage = false;
        StageController.freespinStage = true;

        FreespinsView.symbol6hasWin = 0;
        FreespinsView.symbol5hasWin = 0;
        FreespinsView.symbol4hasWin = 0;
        FreespinsView.symbol3hasWin = 0;
        FreespinsView.symbol2hasWin = 0;
        FreespinsView.symbol1hasWin = 0;

        if (!Utils.isNullOrUndefined(this.messages)) {
            this.messages.goToCase("EMPTY");
        }

        if (GameManager.freespinsResponse.currentWin > 0) {
            if (this.childs["Background"] != null) this.childs["Background"].goToCase("FS_WIN");
        }

        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showInitWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin);

        this.visible = true;

        FreespinsView.customFreespinsCollectionBarsData = DataManager.getCustomFreespinsCollectionBarsData();
        FreespinsView.updateBonusCounterFS();
        FreespinsView.updateFreespinsProgressBarsAndMultipliers(FreespinsView.customFreespinsCollectionBarsData);

        AmbientBackground.changeAmbientBackground("color-1", 0);

        this.retrigger();

        if (FreespinsView.isLastFreespin()) {
            PlayList.stop("SND_FSLoop");
            PlayList.loop("SND_FSEndWait", 300);
            PlayList.play("SND_FSEnd");

            FreespinsView.resetProgressBarsAndMultipliersCases();
            this.totalWin();
        } else {
            PlayList.loop("SND_FSLoop");
        }
    }

    protected layoutChanged() {
        if (ModuleManager.freespinsActive()) {
            this._fsMessageTimerFS.start(0);
        }
    }

    spin(): void {
        StageController.baseStage = false;
        StageController.freespinStage = true;

        PlayList.loop("SND_FSLoop");

        if (!Utils.isNullOrUndefined(this.messages)) {
            if (this.messages.getCurrentCase() == "SHOW_FS" || this.messages.getCurrentCase() == "SHOW_FS_2") {
                this.messages.goToCase("RESET");
            }
        }

        if (this._fsMessageStart != null && !this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageStart.classList.add(HtmlController.DisabledClass);
        }

        if (this.childs["Background"] !== null && this.childs["Background"].getCurrentCase() === "FS_WIN") {
            this.childs["Background"].goToCase("TO_FS");
        }

        this._machine.spinStart(this._winAnimator.reset(true), true, this._winAnimator.currentSymbols);
    }

    stop(): void {
        this._machine.spinStop(null, true);
    }

    startReceived(): void {
        if (this._fsMessageStart != null && !this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageStart.classList.add(HtmlController.DisabledClass);
        }

        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.reset(true);
    }

    spinReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._machine.spinStop(null, false, true);

        FreespinsView.updateBonusCounterFS();
    }

    endReceived(): void {}

    onReelStopped(): void {
        this._winAnimator.onReelStopped(GameManager.freespinsResponse.screen.reels, this._machine.actualReelStopped);
    }

    machineStopped(): void {
        this._controller.machineStopped();

        FreespinsView.customFreespinsCollectionBarsData = DataManager.getCustomFreespinsCollectionBarsData();
        FreespinsView.updateFreespinsProgressBarsAndMultipliers(FreespinsView.customFreespinsCollectionBarsData);

        if (this._winAnimator.showWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin)) {
            PlayList.stop("SND_FSLoop");
        }

        if (GameManager.freespinsResponse.currentWin > 0) {
            if (this.childs["Background"] != null) {
                this.childs["Background"].goToCase("FS_WIN");
            }
        }

        if (GameManager.freespinsResponse.currentWin === 0) {
            if (FreespinsView.isLastFreespin()) {
                PlayList.stop("SND_FSLoop");
                PlayList.loop("SND_FSEndWait");
                PlayList.play("SND_FSEnd");

                this._fsMessageEndTimer.start(30);
            }
        }

        FreespinsView.s1MultiplierCount = FreespinsView.symbol1MultiplierCount;
        FreespinsView.s2MultiplierCount = FreespinsView.symbol2MultiplierCount;
        FreespinsView.s3MultiplierCount = FreespinsView.symbol3MultiplierCount;
        FreespinsView.s4MultiplierCount = FreespinsView.symbol4MultiplierCount;
        FreespinsView.s5MultiplierCount = FreespinsView.symbol5MultiplierCount;
        FreespinsView.s6MultiplierCount = FreespinsView.symbol6MultiplierCount;

        if (FreespinsView.symbol1hasWin == 1) {
            FreespinsView.s1MultiplierCount = 0;
        }
        if (FreespinsView.symbol2hasWin == 1) {
            FreespinsView.s2MultiplierCount = 0;
        }
        if (FreespinsView.symbol3hasWin == 1) {
            FreespinsView.s3MultiplierCount = 0;
        }
        if (FreespinsView.symbol4hasWin == 1) {
            FreespinsView.s4MultiplierCount = 0;
        }
        if (FreespinsView.symbol5hasWin == 1) {
            FreespinsView.s5MultiplierCount = 0;
        }
        if (FreespinsView.symbol6hasWin == 1) {
            FreespinsView.s6MultiplierCount = 0;
        }
        const currentBet = BetManager.Bet;
        let totalWin = GameManager.freespinsResponse.totalWin;
        let totalWinScatter =
            FreespinsView.s1MultiplierCount * currentBet +
            FreespinsView.s2MultiplierCount * currentBet +
            FreespinsView.s3MultiplierCount * currentBet +
            FreespinsView.s4MultiplierCount * currentBet +
            FreespinsView.s5MultiplierCount * currentBet +
            FreespinsView.s6MultiplierCount * currentBet;
        let showWin = totalWin - totalWinScatter;
        FreespinsView.totalWinBeforeFeature = showWin;
    }

    private finishQuickWinCalculation(): void {
        this._controller.quickWinCalculationFinished();
    }

    finishWinCalculation(): void {
        this._controller.winCalculationFinished();
    }

    private finishCustomQuickWinCalculation(): void {}

    finishCustomWinCalculation(): void {}

    finishCustomWinAnimator(): void {
        this.totalWin();
    }

    finishWinAnimator(): void {
        this._controller.allWinsFinished();

        if (FreespinsView.isLastFreespin()) {
            PlayList.stop("SND_FSLoop");
            PlayList.loop("SND_FSEndWait");
            PlayList.play("SND_FSEnd");

            this._fsMessageEndTimer.start(30);
        } else {
            PlayList.loop("SND_FSLoop");
        }

        this.retrigger();
    }

    intro(long: boolean = false): void {
        if (FreespinsView.Transition != null) {
            this.addChild(FreespinsView.Transition);
        }

        if (!Utils.isNullOrUndefined(this.messages)) {
            this.messages.goToCase("EMPTY");
        }

        if (!Utils.isNullOrUndefined(FreespinsView._bonusCounterFS)) {
            FreespinsView._bonusCounterFS.goToCase("RESET");
        }

        if (!Utils.isNullOrUndefined(this.childs["Background"])) {
            this.childs["Background"].goToCase("FS");
        }

        StageController.freespinStage = true;

        FreespinsView.customFreespinsCollectionBarsData = DataManager.getCustomFreespinsCollectionBarsData();
        FreespinsView.updateBonusCounterFS();
        FreespinsView.updateFreespinsProgressBarsAndMultipliers(FreespinsView.customFreespinsCollectionBarsData);

        this.allSwitchElementToCase("NORMAL");

        this.visible = true;

        this._introDelay.start(90);
        AmbientBackground.changeAmbientBackground("color-1", 0, 90);
    }

    introFinished(): void {
        StageController.baseStage = false;
        StageController.freespinStage = true;

        this.visible = true;

        FreespinsView.customFreespinsCollectionBarsData = DataManager.getCustomFreespinsCollectionBarsData();
        FreespinsView.updateFreespinsProgressBarsAndMultipliers(FreespinsView.customFreespinsCollectionBarsData);

        PlayList.loop("SND_FSLoop");

        this._controller.introFinished();
    }

    outro(): void {
        if (FreespinsView.Transition != null) {
            this.addChild(FreespinsView.Transition);
            FreespinsView.Transition.goToCase("OUT");
        }
        StageController.freespinStage = true;

        this.visible = true;
        AmbientBackground.changeAmbientBackground("base", 90);

        PlayList.stop("SND_FSLoop");
        PlayList.stop("SND_FSEndWait");
        PlayList.play("SND_FSTransOut");

        if (!Utils.isNullOrUndefined(this.messages)) {
            if (this.messages.getCurrentCase() == "SHOW_FS" || this.messages.getCurrentCase() == "SHOW_FS_2") {
                this.messages.goToCase("RESET");
            }
        }

        this._outroDelay.start(90);
    }

    outroFinished(): void {
        StageController.freespinStage = false;

        this.visible = false;

        if (!Utils.isNullOrUndefined(this.messages)) {
            this.messages.goToCase("EMPTY");
        }

        this.allSwitchElementToCase("EMPTY");

        this._winAnimator.resetTimer();
        this._controller.outroFinished();

        BaseView.customCollectionBarsDataPreviousSpin = null;
        BaseView.customCollectionBarsDataPreviousSpinBonus = null;
        BaseView.customCollectionBarsData = DataManager.getCustomCollectionBarsData();
        BaseView.updateProgressBarsAndMultipliers(BaseView.customCollectionBarsData);
    }

    enable(): void {
        if (this._fsMessageStart != null && this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageStart.classList.remove(HtmlController.DisabledClass);
        }
    }

    public static updateBonusCounterFS(): void {
        let remainingBonusCount = GameManager.freespinsResponse.freeSpins.remainingCount;

        if (!Utils.isNullOrUndefined(remainingBonusCount)) {
            if (!Utils.isNullOrUndefined(FreespinsView._bonusCounterFS)) {
                FreespinsView._bonusCounterFS.goToCase("RESET");

                if (remainingBonusCount >= 0) {
                    let numberElement = FreespinsView._bonusCounterFS.getChildElementByName(
                        "BonusCounter",
                    ) as ImageTextElement;
                    if (!Utils.isNullOrUndefined(numberElement)) {
                        numberElement.setText(remainingBonusCount.toString());
                    }

                    FreespinsView._bonusCounterFS.goToCase("FS");
                }
            }
        }
    }

    public static updateFreespinsProgressBarsAndMultipliers(customFreespinsCollectionBarsData: any): void {
        if (!Utils.isNullOrUndefined(customFreespinsCollectionBarsData)) {
            let symbol6Count: number;
            let symbol5Count: number;
            let symbol4Count: number;
            let symbol3Count: number;
            let symbol2Count: number;
            let symbol1Count: number;

            this.symbol6MultiplierCount = 0;
            this.symbol5MultiplierCount = 0;
            this.symbol4MultiplierCount = 0;
            this.symbol3MultiplierCount = 0;
            this.symbol2MultiplierCount = 0;
            this.symbol1MultiplierCount = 0;

            const customData = customFreespinsCollectionBarsData;

            if (!Utils.isNullOrUndefined(customData)) {
                if (customData.hasOwnProperty("collectionBars")) {
                    let bonusArray = customData.collectionBars;
                    if (!Utils.isNullOrUndefined(bonusArray)) {
                        symbol1Count = bonusArray[CustomUtils.SymbolCherry];
                        symbol2Count = bonusArray[CustomUtils.SymbolLemon];
                        symbol3Count = bonusArray[CustomUtils.SymbolOrange];
                        symbol4Count = bonusArray[CustomUtils.SymbolPlum];
                        symbol5Count = bonusArray[CustomUtils.SymbolGrape];
                        symbol6Count = bonusArray[CustomUtils.SymbolWatermelon];

                        if (symbol1Count > 9 && symbol1Count <= 99) {
                            this.symbol1MultiplierCount = parseInt(String(symbol1Count)[0]) + 1;
                        } else if (symbol1Count > 99) {
                            let multiplier: string = symbol1Count.toString().substring(0, 2);
                            this.symbol1MultiplierCount = parseInt(multiplier) + 1;
                        }

                        if (symbol2Count > 9 && symbol2Count <= 99) {
                            this.symbol2MultiplierCount = parseInt(String(symbol2Count)[0]) + 1;
                        } else if (symbol2Count > 99) {
                            let multiplier: string = symbol2Count.toString().substring(0, 2);
                            this.symbol2MultiplierCount = parseInt(multiplier) + 1;
                        }

                        if (symbol3Count > 9 && symbol3Count <= 99) {
                            this.symbol3MultiplierCount = parseInt(String(symbol3Count)[0]) + 1;
                        } else if (symbol3Count > 99) {
                            let multiplier: string = symbol3Count.toString().substring(0, 2);
                            this.symbol3MultiplierCount = parseInt(multiplier) + 1;
                        }

                        if (symbol4Count > 9 && symbol4Count <= 99) {
                            this.symbol4MultiplierCount = parseInt(String(symbol4Count)[0]) + 1;
                        } else if (symbol4Count > 99) {
                            let multiplier: string = symbol4Count.toString().substring(0, 2);
                            this.symbol4MultiplierCount = parseInt(multiplier) + 1;
                        }

                        if (symbol5Count > 9 && symbol5Count <= 99) {
                            this.symbol5MultiplierCount = parseInt(String(symbol5Count)[0]) + 1;
                        } else if (symbol5Count > 99) {
                            let multiplier: string = symbol5Count.toString().substring(0, 2);
                            this.symbol5MultiplierCount = parseInt(multiplier) + 1;
                        }

                        if (symbol6Count > 9 && symbol6Count <= 99) {
                            this.symbol6MultiplierCount = parseInt(String(symbol6Count)[0]) + 1;
                        } else if (symbol6Count > 99) {
                            let multiplier: string = symbol6Count.toString().substring(0, 2);
                            this.symbol6MultiplierCount = parseInt(multiplier) + 1;
                        }

                        FreespinsView.setMultipliersCases(
                            symbol1Count,
                            symbol2Count,
                            symbol3Count,
                            symbol4Count,
                            symbol5Count,
                            symbol6Count,
                        );
                    }
                }
            }
        }
    }

    public static resetProgressBarsAndMultipliersCases(): void {
        for (let j = 1; j <= 6; j++) {
            if (!Utils.isNullOrUndefined(FreespinsView["_multiplierS" + j + "FS"])) {
                FreespinsView["_multiplierS" + j + "FS"].goToCase("NORMAL");
            }
        }
    }

    public static setMultipliersCases(
        symbol1Count: number,
        symbol2Count: number,
        symbol3Count: number,
        symbol4Count: number,
        symbol5Count: number,
        symbol6Count: number,
    ): void {
        FreespinsView.customFreespinsCollectionBarsData = DataManager.getCustomFreespinsCollectionBarsData();

        const customData = FreespinsView.customFreespinsCollectionBarsData;
        if (!Utils.isNullOrUndefined(customData)) {
            if (customData.hasOwnProperty("symbolWins")) {
                let bonusArray = customData.symbolWins;
                if (!Utils.isNullOrUndefined(bonusArray)) {
                    FreespinsView.symbol1hasWin = bonusArray[CustomUtils.SymbolCherry];
                    FreespinsView.symbol2hasWin = bonusArray[CustomUtils.SymbolLemon];
                    FreespinsView.symbol3hasWin = bonusArray[CustomUtils.SymbolOrange];
                    FreespinsView.symbol4hasWin = bonusArray[CustomUtils.SymbolPlum];
                    FreespinsView.symbol5hasWin = bonusArray[CustomUtils.SymbolGrape];
                    FreespinsView.symbol6hasWin = bonusArray[CustomUtils.SymbolWatermelon];
                }
            }
        }

        for (let j = 1; j <= 6; j++) {
            let multiplierElement = FreespinsView["_multiplierS" + j + "FS"];

            let symbolCountVar = "symbol" + j + "Count";
            let symbolCount = eval(symbolCountVar);

            let symbolHasWin = "FreespinsView.symbol" + j + "hasWin";
            symbolHasWin = eval(symbolHasWin);

            if (+symbolCount <= 9) {
                if (!Utils.isNullOrUndefined(multiplierElement)) {
                    //multiplierElement.goToCase('BASE');

                    let numberElement = multiplierElement.getChildElementByName("FeatureCounter") as ImageTextElement;
                    if (!Utils.isNullOrUndefined(numberElement)) {
                        numberElement.setText("");
                    }
                }
            } else if (+symbolCount > 9 && +symbolCount <= 99) {
                if (+symbolHasWin == 0) {
                    if (!Utils.isNullOrUndefined(multiplierElement)) {
                        multiplierElement.goToCase("FS_FRAME");
                    }
                } else {
                    if (!Utils.isNullOrUndefined(multiplierElement)) {
                        if (multiplierElement.getCurrentCase() == "FS_FRAME") {
                            multiplierElement.goToCase("FS_FRAME_OUT");
                        } else {
                            multiplierElement.goToCase("FS");
                        }
                    }
                }

                let multiplier = String(symbolCount)[0];
                multiplier = String(parseInt(multiplier) + 1);
                let numberElement = multiplierElement.getChildElementByName("FeatureCounter") as ImageTextElement;

                if (!Utils.isNullOrUndefined(numberElement)) {
                    numberElement.setText("x" + multiplier.toString());
                }
            } else if (+symbolCount > 99) {
                if (+symbolHasWin == 0) {
                    if (!Utils.isNullOrUndefined(multiplierElement)) {
                        multiplierElement.goToCase("FS_FRAME");
                    }
                } else {
                    if (!Utils.isNullOrUndefined(multiplierElement)) {
                        if (multiplierElement.getCurrentCase() == "FS_FRAME") {
                            multiplierElement.goToCase("FS_FRAME_OUT");
                        } else {
                            multiplierElement.goToCase("FS");
                        }
                    }
                }

                let multiplier: string = symbolCount.toString().substring(0, 2);
                multiplier = String(parseInt(multiplier) + 1);
                let numberElement = multiplierElement.getChildElementByName("FeatureCounter") as ImageTextElement;

                if (!Utils.isNullOrUndefined(numberElement)) {
                    numberElement.setText("x" + multiplier.toString());
                }
            }
        }
    }

    public showFsMessageFS(): void {
        this._fsMessageTimerFS.stop();
        this.retrigger();
    }

    private retrigger(): void {
        if (!FreespinsView.isLastFreespin()) {
            if (GameManager.freespinsResponse.wins != null && GameManager.freespinsResponse.wins.length > 0) {
                for (let i: number = 0; i < GameManager.freespinsResponse.wins.length; i++) {
                    if (GameManager.freespinsResponse.wins[i].trigger === Communication.Game.WinTrigger.Scatter) {
                        if (this.messages != null) {
                            const customData = GameManager.freespinsResponse.wins[i].customData;

                            if (!Utils.isNullOrUndefined(customData)) {
                                if (customData.hasOwnProperty("count")) {
                                    this.messages.goToCase("SHOW_FS");
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    public static isLastFreespin(): boolean {
        if (DataManager.GameLimit) {
            return true;
        }

        return (
            GameManager.freespinsResponse.freeSpins != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount === 0
        );
    }

    protected showFsMessageEnd(): void {
        this._fsMessageEndTimer.stop();

        CustomUtils.swapChilds(this._winAnimator, "SwapWinAnimator", this);

        FreespinsView.s1MultiplierCount = FreespinsView.symbol1MultiplierCount;
        FreespinsView.s2MultiplierCount = FreespinsView.symbol2MultiplierCount;
        FreespinsView.s3MultiplierCount = FreespinsView.symbol3MultiplierCount;
        FreespinsView.s4MultiplierCount = FreespinsView.symbol4MultiplierCount;
        FreespinsView.s5MultiplierCount = FreespinsView.symbol5MultiplierCount;
        FreespinsView.s6MultiplierCount = FreespinsView.symbol6MultiplierCount;

        if (FreespinsView.symbol1hasWin == 1) {
            FreespinsView.s1MultiplierCount = 0;
        }
        if (FreespinsView.symbol2hasWin == 1) {
            FreespinsView.s2MultiplierCount = 0;
        }
        if (FreespinsView.symbol3hasWin == 1) {
            FreespinsView.s3MultiplierCount = 0;
        }
        if (FreespinsView.symbol4hasWin == 1) {
            FreespinsView.s4MultiplierCount = 0;
        }
        if (FreespinsView.symbol5hasWin == 1) {
            FreespinsView.s5MultiplierCount = 0;
        }
        if (FreespinsView.symbol6hasWin == 1) {
            FreespinsView.s6MultiplierCount = 0;
        }

        const currentBet = BetManager.Bet;
        let totalWin = GameManager.freespinsResponse.totalWin;
        let totalWinScatter =
            FreespinsView.s1MultiplierCount * currentBet +
            FreespinsView.s2MultiplierCount * currentBet +
            FreespinsView.s3MultiplierCount * currentBet +
            FreespinsView.s4MultiplierCount * currentBet +
            FreespinsView.s5MultiplierCount * currentBet +
            FreespinsView.s6MultiplierCount * currentBet;
        let showWin = totalWin - totalWinScatter;
        FreespinsView.totalWinBeforeFeature = showWin;

        let win = CustomUtils.formatWinNumber(showWin);

        /*if (!Utils.isNullOrUndefined(this.messages)) {
            let fsWinCount = this.messages.getChildElementByName('FsWinCount') as ImageTextElement;
            if (!Utils.isNullOrUndefined(fsWinCount)) {
                fsWinCount.setText(win.toString());
            }

            if (totalWinScatter > 0) {
                this.messages.goToCase('SHOW_FS_END');
            }
        }*/

        FreespinsView.customFreespinsCollectionBarsData = DataManager.getCustomFreespinsCollectionBarsData();
        const customData = FreespinsView.customFreespinsCollectionBarsData;
        if (!Utils.isNullOrUndefined(customData)) {
            if (customData.hasOwnProperty("symbolWins")) {
                let bonusArray = customData.symbolWins;
                if (!Utils.isNullOrUndefined(bonusArray)) {
                    FreespinsView.symbol6hasWin = bonusArray[CustomUtils.SymbolWatermelon];
                    FreespinsView.symbol5hasWin = bonusArray[CustomUtils.SymbolGrape];
                    FreespinsView.symbol4hasWin = bonusArray[CustomUtils.SymbolPlum];
                    FreespinsView.symbol3hasWin = bonusArray[CustomUtils.SymbolOrange];
                    FreespinsView.symbol2hasWin = bonusArray[CustomUtils.SymbolLemon];
                    FreespinsView.symbol1hasWin = bonusArray[CustomUtils.SymbolCherry];
                }
            }
        }

        let delay = 30;

        if (FreespinsView.symbol5MultiplierCount > 0 && FreespinsView.symbol5hasWin == 0) {
            this._popS5Timer.start(delay);
            delay += 60;
        } else if (FreespinsView.symbol5MultiplierCount > 0 && FreespinsView.symbol5hasWin == 1) {
            if (!Utils.isNullOrUndefined(FreespinsView["_multiplierS5FS"])) {
                FreespinsView["_multiplierS5FS"].goToCase("FS_OUT");
            }
        }

        if (FreespinsView.symbol6MultiplierCount > 0 && FreespinsView.symbol6hasWin == 0) {
            this._popS6Timer.start(delay);
            delay += 60;
        } else if (FreespinsView.symbol6MultiplierCount > 0 && FreespinsView.symbol6hasWin == 1) {
            if (!Utils.isNullOrUndefined(FreespinsView["_multiplierS6FS"])) {
                FreespinsView["_multiplierS6FS"].goToCase("FS_OUT");
            }
        }

        if (FreespinsView.symbol3MultiplierCount > 0 && FreespinsView.symbol3hasWin == 0) {
            this._popS3Timer.start(delay);
            delay += 60;
        } else if (FreespinsView.symbol3MultiplierCount > 0 && FreespinsView.symbol3hasWin == 1) {
            if (!Utils.isNullOrUndefined(FreespinsView["_multiplierS3FS"])) {
                FreespinsView["_multiplierS3FS"].goToCase("FS_OUT");
            }
        }

        if (FreespinsView.symbol4MultiplierCount > 0 && FreespinsView.symbol4hasWin == 0) {
            this._popS4Timer.start(delay);
            delay += 60;
        } else if (FreespinsView.symbol4MultiplierCount > 0 && FreespinsView.symbol4hasWin == 1) {
            if (!Utils.isNullOrUndefined(FreespinsView["_multiplierS4FS"])) {
                FreespinsView["_multiplierS4FS"].goToCase("FS_OUT");
            }
        }

        if (FreespinsView.symbol1MultiplierCount > 0 && FreespinsView.symbol1hasWin == 0) {
            this._popS1Timer.start(delay);
            delay += 60;
        } else if (FreespinsView.symbol1MultiplierCount > 0 && FreespinsView.symbol1hasWin == 1) {
            if (!Utils.isNullOrUndefined(FreespinsView["_multiplierS1FS"])) {
                FreespinsView["_multiplierS1FS"].goToCase("FS_OUT");
            }
        }

        if (FreespinsView.symbol2MultiplierCount > 0 && FreespinsView.symbol2hasWin == 0) {
            this._popS2Timer.start(delay);
            delay += 60;
        } else if (FreespinsView.symbol2MultiplierCount > 0 && FreespinsView.symbol2hasWin == 1) {
            if (!Utils.isNullOrUndefined(FreespinsView["_multiplierS2FS"])) {
                FreespinsView["_multiplierS2FS"].goToCase("FS_OUT");
            }
        }

        if (totalWinScatter > 0) {
            //todo Play winanimation with "totalWinScatter" value
            this._startCustomAnimationTimer.once(
                FrameTimerEvents.Complete,
                this.startCustomAnimation.bind(this, totalWinScatter),
            );
            this._startCustomAnimationTimer.start(delay + 30);
            //this._totalWinTimer.start(delay + 30);
        } else {
            if (!Utils.isNullOrUndefined(this.messages)) {
                //this._totalWinTimer.start(0);
                this.totalWin();
            }
        }
    }

    startCustomAnimation(totalWinScatter: number) {
        this._startCustomAnimationTimer.stop();
        this._winAnimator.startCustomAnimation(1, totalWinScatter);
    }

    popS6totalwin(): void {
        this._popS6Timer.stop();

        if (!Utils.isNullOrUndefined(FreespinsView["_multiplierS6FS"])) {
            let multiplier = FreespinsView.symbol6MultiplierCount;
            FreespinsView["_multiplierS6FS"].goToCase("FS_POP_TOTALWIN");
            PlayList.play("SND_FSEndCountingMelonA");

            let numberElementS6 = FreespinsView["_multiplierS6FS"].getChildElementByName(
                "FeatureCounter",
            ) as ImageTextElement;
            if (!Utils.isNullOrUndefined(numberElementS6)) {
                numberElementS6.setText("x" + multiplier.toString());
            }

            let popWin = FreespinsView.symbol6MultiplierCount * BetManager.Bet;
            let win = CustomUtils.formatWinNumber(popWin);

            let numberElement = FreespinsView._multiplierS6FS.getChildElementByName("WinCount") as ImageTextElement;
            if (!Utils.isNullOrUndefined(numberElement)) {
                numberElement.setText(win.toString());
            }

            this._popS6SoundTimer.start(50);
            this._popS6CounterTimer.start(90);
        }
    }

    popS6sound(): void {
        this._popS6SoundTimer.stop();
        PlayList.play("SND_FSEndCountingMelonB");
    }

    popS6counter(): void {
        this._popS6CounterTimer.stop();
        PlayList.play("SND_FSEndCountingMelonC");

        const currentBet = BetManager.Bet;
        let totalWin = GameManager.freespinsResponse.totalWin;
        let totalWinScatter =
            FreespinsView.s1MultiplierCount * currentBet +
            FreespinsView.s2MultiplierCount * currentBet +
            FreespinsView.s3MultiplierCount * currentBet +
            FreespinsView.s4MultiplierCount * currentBet +
            FreespinsView.s5MultiplierCount * currentBet +
            FreespinsView.s6MultiplierCount * currentBet;
        let showWinPop =
            totalWin -
            totalWinScatter +
            FreespinsView.s5MultiplierCount * currentBet +
            FreespinsView.s6MultiplierCount * currentBet;
        FreespinsView.totalWinPopS6 = showWinPop;

        let win = CustomUtils.formatWinNumber(showWinPop);

        if (!Utils.isNullOrUndefined(this.messages)) {
            let fsWinCount = this.messages.getChildElementByName("FsWinCount") as ImageTextElement;
            if (!Utils.isNullOrUndefined(fsWinCount)) {
                fsWinCount.setText(win.toString());
            }

            //this.messages.goToCase('SHOW_FS_POP_6');
        }

        this._controller.popS6finished();
    }

    popS5totalwin(): void {
        this._popS5Timer.stop();

        if (!Utils.isNullOrUndefined(FreespinsView["_multiplierS5FS"])) {
            let multiplier = FreespinsView.symbol5MultiplierCount;
            FreespinsView["_multiplierS5FS"].goToCase("FS_POP_TOTALWIN");
            PlayList.play("SND_FSEndCountingGrapeA");

            let numberElementS5 = FreespinsView["_multiplierS5FS"].getChildElementByName(
                "FeatureCounter",
            ) as ImageTextElement;
            if (!Utils.isNullOrUndefined(numberElementS5)) {
                numberElementS5.setText("x" + multiplier.toString());
            }

            let popWin = FreespinsView.symbol5MultiplierCount * BetManager.Bet;
            let win = CustomUtils.formatWinNumber(popWin);

            let numberElement = FreespinsView._multiplierS5FS.getChildElementByName("WinCount") as ImageTextElement;
            if (!Utils.isNullOrUndefined(numberElement)) {
                numberElement.setText(win.toString());
            }

            this._popS5SoundTimer.start(50);
            this._popS5CounterTimer.start(90);
        }
    }

    popS5sound(): void {
        this._popS5SoundTimer.stop();
        PlayList.play("SND_FSEndCountingGrapeB");
    }

    popS5counter(): void {
        this._popS5CounterTimer.stop();
        PlayList.play("SND_FSEndCountingGrapeC");

        const currentBet = BetManager.Bet;
        let totalWin = GameManager.freespinsResponse.totalWin;
        let totalWinScatter =
            FreespinsView.s1MultiplierCount * currentBet +
            FreespinsView.s2MultiplierCount * currentBet +
            FreespinsView.s3MultiplierCount * currentBet +
            FreespinsView.s4MultiplierCount * currentBet +
            FreespinsView.s5MultiplierCount * currentBet +
            FreespinsView.s6MultiplierCount * currentBet;
        let showWinPop = totalWin - totalWinScatter + FreespinsView.s5MultiplierCount * currentBet;
        FreespinsView.totalWinPopS5 = showWinPop;

        let win = CustomUtils.formatWinNumber(showWinPop);

        if (!Utils.isNullOrUndefined(this.messages)) {
            let fsWinCount = this.messages.getChildElementByName("FsWinCount") as ImageTextElement;
            if (!Utils.isNullOrUndefined(fsWinCount)) {
                fsWinCount.setText(win.toString());
            }

            //this.messages.goToCase('SHOW_FS_POP_5');
        }

        this._controller.popS5finished();
    }

    popS4totalwin(): void {
        this._popS4Timer.stop();

        if (!Utils.isNullOrUndefined(FreespinsView["_multiplierS4FS"])) {
            let multiplier = FreespinsView.symbol4MultiplierCount;
            FreespinsView["_multiplierS4FS"].goToCase("FS_POP_TOTALWIN");
            PlayList.play("SND_FSEndCountingPlumA");

            let numberElementS4 = FreespinsView["_multiplierS4FS"].getChildElementByName(
                "FeatureCounter",
            ) as ImageTextElement;
            if (!Utils.isNullOrUndefined(numberElementS4)) {
                numberElementS4.setText("x" + multiplier.toString());
            }

            let popWin = FreespinsView.symbol4MultiplierCount * BetManager.Bet;
            let win = CustomUtils.formatWinNumber(popWin);

            let numberElement = FreespinsView._multiplierS4FS.getChildElementByName("WinCount") as ImageTextElement;
            if (!Utils.isNullOrUndefined(numberElement)) {
                numberElement.setText(win.toString());
            }

            this._popS4SoundTimer.start(50);
            this._popS4CounterTimer.start(90);
        }
    }

    popS4sound(): void {
        this._popS4SoundTimer.stop();
        PlayList.play("SND_FSEndCountingPlumB");
    }

    popS4counter(): void {
        this._popS4CounterTimer.stop();
        PlayList.play("SND_FSEndCountingPlumC");

        const currentBet = BetManager.Bet;
        let totalWin = GameManager.freespinsResponse.totalWin;
        let totalWinScatter =
            FreespinsView.s1MultiplierCount * currentBet +
            FreespinsView.s2MultiplierCount * currentBet +
            FreespinsView.s3MultiplierCount * currentBet +
            FreespinsView.s4MultiplierCount * currentBet +
            FreespinsView.s5MultiplierCount * currentBet +
            FreespinsView.s6MultiplierCount * currentBet;
        let showWinPop =
            totalWin -
            totalWinScatter +
            FreespinsView.s5MultiplierCount * currentBet +
            FreespinsView.s6MultiplierCount * currentBet +
            FreespinsView.s3MultiplierCount * currentBet +
            FreespinsView.s4MultiplierCount * currentBet;
        FreespinsView.totalWinPopS4 = showWinPop;

        let win = CustomUtils.formatWinNumber(showWinPop);

        if (!Utils.isNullOrUndefined(this.messages)) {
            let fsWinCount = this.messages.getChildElementByName("FsWinCount") as ImageTextElement;
            if (!Utils.isNullOrUndefined(fsWinCount)) {
                fsWinCount.setText(win.toString());
            }

            //this.messages.goToCase('SHOW_FS_POP_4');
        }

        this._controller.popS4finished();
    }

    popS3totalwin(): void {
        this._popS3Timer.stop();

        if (!Utils.isNullOrUndefined(FreespinsView["_multiplierS3FS"])) {
            let multiplier = FreespinsView.symbol3MultiplierCount;
            FreespinsView["_multiplierS3FS"].goToCase("FS_POP_TOTALWIN");
            PlayList.play("SND_FSEndCountingOrangeA");

            let numberElementS3 = FreespinsView["_multiplierS3FS"].getChildElementByName(
                "FeatureCounter",
            ) as ImageTextElement;
            if (!Utils.isNullOrUndefined(numberElementS3)) {
                numberElementS3.setText("x" + multiplier.toString());
            }

            let popWin = FreespinsView.symbol3MultiplierCount * BetManager.Bet;
            let win = CustomUtils.formatWinNumber(popWin);

            let numberElement = FreespinsView._multiplierS3FS.getChildElementByName("WinCount") as ImageTextElement;
            if (!Utils.isNullOrUndefined(numberElement)) {
                numberElement.setText(win.toString());
            }

            this._popS3SoundTimer.start(50);
            this._popS3CounterTimer.start(90);
        }
    }

    popS3sound(): void {
        this._popS3SoundTimer.stop();
        PlayList.play("SND_FSEndCountingOrangeB");
    }

    popS3counter(): void {
        this._popS3CounterTimer.stop();
        PlayList.play("SND_FSEndCountingOrangeC");

        const currentBet = BetManager.Bet;
        let totalWin = GameManager.freespinsResponse.totalWin;
        let totalWinScatter =
            FreespinsView.s1MultiplierCount * currentBet +
            FreespinsView.s2MultiplierCount * currentBet +
            FreespinsView.s3MultiplierCount * currentBet +
            FreespinsView.s4MultiplierCount * currentBet +
            FreespinsView.s5MultiplierCount * currentBet +
            FreespinsView.s6MultiplierCount * currentBet;
        let showWinPop =
            totalWin -
            totalWinScatter +
            FreespinsView.s5MultiplierCount * currentBet +
            FreespinsView.s6MultiplierCount * currentBet +
            FreespinsView.s3MultiplierCount * currentBet;

        FreespinsView.totalWinPopS3 = showWinPop;

        let win = CustomUtils.formatWinNumber(showWinPop);

        if (!Utils.isNullOrUndefined(this.messages)) {
            let fsWinCount = this.messages.getChildElementByName("FsWinCount") as ImageTextElement;
            if (!Utils.isNullOrUndefined(fsWinCount)) {
                fsWinCount.setText(win.toString());
            }

            //this.messages.goToCase('SHOW_FS_POP_3');
        }

        this._controller.popS3finished();
    }

    popS2totalwin(): void {
        this._popS2Timer.stop();

        if (!Utils.isNullOrUndefined(FreespinsView["_multiplierS2FS"])) {
            let multiplier = FreespinsView.symbol2MultiplierCount;
            FreespinsView["_multiplierS2FS"].goToCase("FS_POP_TOTALWIN");
            PlayList.play("SND_FSEndCountingLemonA");

            let numberElementS2 = FreespinsView["_multiplierS2FS"].getChildElementByName(
                "FeatureCounter",
            ) as ImageTextElement;
            if (!Utils.isNullOrUndefined(numberElementS2)) {
                numberElementS2.setText("x" + multiplier.toString());
            }

            let popWin = FreespinsView.symbol2MultiplierCount * BetManager.Bet;
            let win = CustomUtils.formatWinNumber(popWin);

            let numberElement = FreespinsView._multiplierS2FS.getChildElementByName("WinCount") as ImageTextElement;
            if (!Utils.isNullOrUndefined(numberElement)) {
                numberElement.setText(win.toString());
            }

            this._popS2SoundTimer.start(50);
            this._popS2CounterTimer.start(90);
        }
    }

    popS2sound(): void {
        this._popS2SoundTimer.stop();
        PlayList.play("SND_FSEndCountingLemonB");
    }

    popS2counter(): void {
        this._popS2CounterTimer.stop();
        PlayList.play("SND_FSEndCountingLemonC");

        const currentBet = BetManager.Bet;
        let totalWin = GameManager.freespinsResponse.totalWin;
        let totalWinScatter =
            FreespinsView.s1MultiplierCount * currentBet +
            FreespinsView.s2MultiplierCount * currentBet +
            FreespinsView.s3MultiplierCount * currentBet +
            FreespinsView.s4MultiplierCount * currentBet +
            FreespinsView.s5MultiplierCount * currentBet +
            FreespinsView.s6MultiplierCount * currentBet;
        let showWinPop =
            totalWin -
            totalWinScatter +
            FreespinsView.s5MultiplierCount * currentBet +
            FreespinsView.s6MultiplierCount * currentBet +
            FreespinsView.s3MultiplierCount * currentBet +
            FreespinsView.s4MultiplierCount * currentBet +
            FreespinsView.s1MultiplierCount * currentBet +
            FreespinsView.s2MultiplierCount * currentBet;

        FreespinsView.totalWinPopS2 = showWinPop;

        let win = CustomUtils.formatWinNumber(showWinPop);

        if (!Utils.isNullOrUndefined(this.messages)) {
            let fsWinCount = this.messages.getChildElementByName("FsWinCount") as ImageTextElement;
            if (!Utils.isNullOrUndefined(fsWinCount)) {
                fsWinCount.setText(win.toString());
            }

            //this.messages.goToCase('SHOW_FS_POP_2');
        }

        this._controller.popS2finished();
    }

    popS1totalwin(): void {
        this._popS1Timer.stop();

        if (!Utils.isNullOrUndefined(FreespinsView["_multiplierS1FS"])) {
            let multiplier = FreespinsView.symbol1MultiplierCount;
            FreespinsView["_multiplierS1FS"].goToCase("FS_POP_TOTALWIN");
            PlayList.play("SND_FSEndCountingCherryA");

            let numberElementS1 = FreespinsView["_multiplierS1FS"].getChildElementByName(
                "FeatureCounter",
            ) as ImageTextElement;
            if (!Utils.isNullOrUndefined(numberElementS1)) {
                numberElementS1.setText("x" + multiplier.toString());
            }

            let popWin = FreespinsView.symbol1MultiplierCount * BetManager.Bet;
            let win = CustomUtils.formatWinNumber(popWin);

            let numberElement = FreespinsView._multiplierS1FS.getChildElementByName("WinCount") as ImageTextElement;
            if (!Utils.isNullOrUndefined(numberElement)) {
                numberElement.setText(win.toString());
            }

            this._popS1SoundTimer.start(50);
            this._popS1CounterTimer.start(90);
        }
    }

    popS1sound(): void {
        this._popS1SoundTimer.stop();
        PlayList.play("SND_FSEndCountingCherryB");
    }

    popS1counter(): void {
        this._popS1CounterTimer.stop();
        PlayList.play("SND_FSEndCountingCherryC");

        const currentBet = BetManager.Bet;
        let totalWin = GameManager.freespinsResponse.totalWin;
        let totalWinScatter =
            FreespinsView.s1MultiplierCount * currentBet +
            FreespinsView.s2MultiplierCount * currentBet +
            FreespinsView.s3MultiplierCount * currentBet +
            FreespinsView.s4MultiplierCount * currentBet +
            FreespinsView.s5MultiplierCount * currentBet +
            FreespinsView.s6MultiplierCount * currentBet;
        let showWinPop =
            totalWin -
            totalWinScatter +
            FreespinsView.s5MultiplierCount * currentBet +
            FreespinsView.s6MultiplierCount * currentBet +
            FreespinsView.s3MultiplierCount * currentBet +
            FreespinsView.s4MultiplierCount * currentBet +
            FreespinsView.s1MultiplierCount * currentBet;
        FreespinsView.totalWinPopS1 = showWinPop;

        let win = CustomUtils.formatWinNumber(showWinPop);

        if (!Utils.isNullOrUndefined(this.messages)) {
            let fsWinCount = this.messages.getChildElementByName("FsWinCount") as ImageTextElement;
            if (!Utils.isNullOrUndefined(fsWinCount)) {
                fsWinCount.setText(win.toString());
            }

            //this.messages.goToCase('SHOW_FS_POP_1');
        }

        this._controller.popS1finished();
    }

    totalWin(): void {
        this._totalWinTimer.stop();

        PlayList.play("SND_FSTotalWin");

        let totalWin = GameManager.freespinsResponse.totalWin;
        //let showWin = totalWin;
        FreespinsView.totalWinFinished = totalWin;

        let win = CustomUtils.formatWinNumber(totalWin);

        if (!Utils.isNullOrUndefined(this.messages)) {
            let fsWinCount = this.messages.getChildElementByName("FsWinCount") as ImageTextElement;
            if (!Utils.isNullOrUndefined(fsWinCount)) {
                fsWinCount.setText(win.toString());
            }

            this.messages.goToCase("SHOW_TOTAL_WIN");
        }

        this._controller.totalWinfinished();
    }

    private allSwitchElementToCase(caseType: string): void {
        for (let key in this.childs) {
            if (this.childs[key] instanceof SwitchElement) {
                let elem: SwitchElement = this.childs[key];

                if (elem.hasCase(caseType)) {
                    elem.goToCase(caseType);
                }
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Freespins/FreespinsView.ts
 **/